import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IAdHocLine extends IBaseEntity {
    id?: number;
    amount: number;
    description: string;
    nominalCodeId?: number;
    nominalCodeDetails?: any;
}

export class AdHocLine extends BaseEntity implements IAdHocLine {
    public id?: number;
    public amount: number;
    public description: string;
    public nominalCodeId?: number;
    public nominalCodeDetails?: any;

    constructor(adHocLine?: any) {
        super();
        if (adHocLine) {
            this.id = adHocLine.id;
            this.amount = adHocLine.amount;
            this.description = adHocLine.description;
            this.nominalCodeId = adHocLine.nominalCodeId;
            this.nominalCodeDetails = adHocLine.nominalCodeDetails;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): AdHocLine {
        return new AdHocLine(this);
    }
}
